// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"226":"679ce304","539":"34c3d213"}[chunkId] + ".chunk.js";
};